import { render, staticRenderFns } from "./CampaignRoiReport.vue?vue&type=template&id=fc625f48&"
import script from "./CampaignRoiReport.vue?vue&type=script&lang=js&"
export * from "./CampaignRoiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports